import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API,
    timeout: 60000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

const unwrap = (response) => response?.data?.data ?? response?.data;
const base = "/inventory/sale-receipts";

const electronicDocumentsApi = {
    sequences: () => api.get("/inventory/electronic-sequences").then(unwrap),
    configureSequence: (payload) => api.put("/inventory/electronic-sequences", payload).then(unwrap),
    list: (params = {}) => api.get(base, { params }).then(unwrap),
    detail: (id) => api.get(`${base}/${id}`).then(unwrap),
    preflight: (id) => api.get(`${base}/${id}/sunat-preflight`).then(unwrap),
    observations: (id) => api.get(`${base}/${id}/observations`).then(unwrap),
    retry: (id) => api.post(`${base}/${id}/retry`).then(unwrap),
    remove: (id, reason) =>
        api.delete(`${base}/${id}`, { data: { reason } }).then(unwrap),
    createCreditNote: (id, payload) =>
        api.post(`${base}/${id}/credit-notes`, payload).then(unwrap),
    cancelSale: (id, payload) =>
        api.post(`${base}/${id}/cancel-sale`, payload).then(unwrap),
    promotionGiftReturnDetail: (registerId) => api.get(`/promotion-gifts/returns/register/${registerId}`).then(unwrap),
    confirmPromotionGiftReturn: (noteId, giftIds) => api.post(`/promotion-gifts/credit-notes/${noteId}/confirm-return`, { physicalReturnConfirmed: true, giftIds }).then(unwrap),
    creditNotes: (id) => api.get(`${base}/${id}/credit-notes`).then(unwrap),
    creditNoteDetail: (id) => api.get(`/inventory/credit-notes/${id}`).then(unwrap),
    creditNotePreflight: (id) =>
        api.get(`/inventory/credit-notes/${id}/sunat-preflight`).then(unwrap),
    creditNoteRetry: (id) =>
        api.post(`/inventory/credit-notes/${id}/retry`).then(unwrap),
    creditNoteRetryInventory: (id) =>
        api.post(`/inventory/credit-notes/${id}/retry-inventory`).then(unwrap),
    accessoryCreditNoteRestoreStock: (id) =>
        api.post(`/accessory-sales/credit-notes/${id}/restore-stock`).then(unwrap),
    creditNoteObservations: (id) =>
        api.get(`/inventory/credit-notes/${id}/observations`).then(unwrap),
    downloadCreditNote: async (id, type, filename) => {
        const response = await api.get(`/inventory/credit-notes/${id}/${type}`, {
            responseType: "blob",
        });
        const url = URL.createObjectURL(response.data);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    },
    download: async (id, type, filename) => {
        const response = await api.get(`${base}/${id}/${type}`, {
            responseType: "blob",
        });
        const url = URL.createObjectURL(response.data);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    },
};

export default electronicDocumentsApi;
